import React from "react";

const ArrowExpand = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="11.7019"
        height="2.00009"
        rx="1.00004"
        transform="matrix(0.707107 -0.707107 0.700432 0.713719 14.0293 20.2744)"
        fill="#00A799"
      />
      <rect
        width="11.7019"
        height="1.86718"
        rx="0.933591"
        transform="matrix(-0.707107 -0.707107 0.700432 -0.713719 22.2754 28.5479)"
        fill="#00A799"
      />
    </svg>
  );
};

export default ArrowExpand;
